import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    accuratePriceField:{
        flexDirection: 'row',
        alignItems:'baseline',
        justifyContent: 'flex-end'
    },
    priceDiscount:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#999999",
        textAlign: "right",
        height: 14,
    },
    priceColor:{
        color: "#FF6600"
    },
    label:{
        backgroundColor: "#EBFFF8",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 8,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 0,
        paddingHorizontal:6,
        height: 14,
        top:0,
        right:0,
        position: 'absolute'
    },
    labelText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#00B87A",
        height: 14,
    },
    cheapList:{
        flex: 1
    },
    priceBaseInfo:{
        paddingHorizontal: 16,
    },
    priceCardBlock:{
        flexDirection:'row',
        marginLeft: 8,
        marginRight: 16,
    },
    cheapPriceCard:{
        paddingVertical: 12,
        flex: 1,
        backgroundColor: "#FFFFFF",
        borderRadius: 8,
        marginLeft:8,
        marginTop: 8
    },
    priceTrendField:{
        height: 97,
        width: '100%'
    },
    priceTrendPic:{
        width: '100%',
        height: '100%'

    },
    priceTrendPercent:{
        position: 'absolute',
        left: '50%',
        marginLeft: -29,
        top: 11,
        backgroundColor: "#EE1D2F",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowRadius: 8,
        shadowColor: "rgba(238,29,47,0.20)",
        elevation: 8,
        borderRadius: 14,
        width: 58,
        height: 24,
        flexDirection:'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    priceTrendPercentTip:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 12,
        color: "#FFFFFF"
    },
    priceTrendPercentText:{
        fontFamily: "hotel_rn_num_v1",
        fontSize: 12,
        color: "#FFFFFF"
    },
    lowPrice:{
        flexDirection:'row',
        alignItems: 'baseline',
        position: 'absolute',
        bottom: 6,
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center',
    },

    lowPriceTip:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 14,
        color: "#FF6600",
    },

    lowPriceText:{
        fontFamily: "hotel_rn_num_v1",
        fontSize: 20,
        color: "#FF6600",
        height: 24,
    },

    averagePrice:{
        flexDirection: 'row',
        alignItems: 'baseline',
        justifyContent: 'center'
    },
    averagePriceTip:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 12,
        transform:[{scaleX: 0.85}, {scaleY: 0.85}],
        color: "#999999",
        height: 14,
        lineHeight: 14
    },
    averatePriceText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 12,
        transform:[{scaleX: 0.85}, {scaleY: 0.85}],
        color: "#FF6600",
        height: 14,
        alignSelf: 'center',
        marginLeft: -7,
        lineHeight: 14
    },
    averagePriceAfterTip:{
        marginLeft: -7
    }


});